

















































































import Vue from 'vue'

import RouteAssistant from '@/helpers/route-assistant'

export default Vue.extend({
  name: 'AppHeaderDropdownMenu',

  data() {
    return {
      RouteAssistant,
      signOutUrl: `${process.env.VUE_APP_SERVER_SIDE_APP_URL}/security/logout`,
      helpDocsUrl: 'https://www.donedone.com/help-center/donedone-2-help-docs',
      supportUrl: 'https://www.donedone.com/help-center',
      isDarkTheme: localStorage.getItem('theme') === 'dark',
    }
  },

  computed: {
    accountID(): string {
      return this.$route.params.accountId
    },
  },

  methods: {
    toggleTheme() {
      this.isDarkTheme = !this.isDarkTheme
      document.documentElement.setAttribute(
        'data-theme',
        this.isDarkTheme ? 'dark' : 'light',
      )

      localStorage.setItem('theme', this.isDarkTheme ? 'dark' : 'light')
    },
    created() {
      this.isDarkTheme = localStorage.getItem('theme') === 'dark'
    },
  },
})
